/**
 * @flow
 * @relayHash c02728398ce6030633dd9741436b6050
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type DisallowedPagesTable_project$ref = any;
export type indexing_IndexingCategory_DisallowedPagesTable_QueryVariables = {|
  host: string
|};
export type indexing_IndexingCategory_DisallowedPagesTable_QueryResponse = {|
  +project: ?{|
    +$fragmentRefs: DisallowedPagesTable_project$ref
  |}
|};
export type indexing_IndexingCategory_DisallowedPagesTable_Query = {|
  variables: indexing_IndexingCategory_DisallowedPagesTable_QueryVariables,
  response: indexing_IndexingCategory_DisallowedPagesTable_QueryResponse,
|};
*/


/*
query indexing_IndexingCategory_DisallowedPagesTable_Query(
  $host: String!
) {
  project(host: $host) {
    ...DisallowedPagesTable_project
    id
  }
}

fragment DisallowedPagesTable_project on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        disallowedPages(offset: 0, limit: 20, url: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}, sitemapFilter: {showInSitemap: true, showNotInSitemap: true}) {
          count
          edges {
            node {
              ...DisallowedPagesRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment DisallowedPagesRow_issue on DisallowedPage {
  id
  type
  severity
  url
  source_url
  sitemap_url
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Literal",
  "name": "offset",
  "value": 0,
  "type": "Int"
},
v3 = {
  "operator": "AND",
  "values": ([]/*: any*/)
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "indexing_IndexingCategory_DisallowedPagesTable_Query",
  "id": null,
  "text": "query indexing_IndexingCategory_DisallowedPagesTable_Query(\n  $host: String!\n) {\n  project(host: $host) {\n    ...DisallowedPagesTable_project\n    id\n  }\n}\n\nfragment DisallowedPagesTable_project on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        disallowedPages(offset: 0, limit: 20, url: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}, sitemapFilter: {showInSitemap: true, showNotInSitemap: true}) {\n          count\n          edges {\n            node {\n              ...DisallowedPagesRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment DisallowedPagesRow_issue on DisallowedPage {\n  id\n  type\n  severity\n  url\n  source_url\n  sitemap_url\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "indexing_IndexingCategory_DisallowedPagesTable_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "DisallowedPagesTable_project",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "indexing_IndexingCategory_DisallowedPagesTable_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              v2
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "disallowedPages",
                        "storageKey": "disallowedPages(limit:20,offset:0,sitemapFilter:{\"showInSitemap\":true,\"showNotInSitemap\":true},sourceUrl:{\"operator\":\"AND\",\"values\":[]},url:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 20,
                            "type": "Int"
                          },
                          v2,
                          {
                            "kind": "Literal",
                            "name": "sitemapFilter",
                            "value": {
                              "showInSitemap": true,
                              "showNotInSitemap": true
                            },
                            "type": "SitemapFilter"
                          },
                          {
                            "kind": "Literal",
                            "name": "sourceUrl",
                            "value": v3,
                            "type": "TextFilters"
                          },
                          {
                            "kind": "Literal",
                            "name": "url",
                            "value": v3,
                            "type": "TextFilters"
                          }
                        ],
                        "concreteType": "DisallowedPageConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "count",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "DisallowedPageEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "DisallowedPage",
                                "plural": false,
                                "selections": [
                                  v4,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "type",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "severity",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "sitemap_url",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v4
                    ]
                  }
                ]
              }
            ]
          },
          v4
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a6087eb000db6497ed0f10458cd40185';
module.exports = node;
